/*
 * 路由配置（第二光源平台顾客端 + 管理后台）
 *  - 顾客端：home / templates / detail / profiles / modeling / preview / unlock / wallet / works / account / login / support
 *  - 管理后台：/admin 下的品牌、目录、业务只读查询
 *  - mode = hash：URL 形如 /#/home，无需服务器额外配置
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { bindNavigator } from '../components/shared/navigation'
import { markCatalogReturn, catalogRestoredScroll } from '../components/shared/catalog-browse-memory'

Vue.use(VueRouter)

const TemplatesPage = () => import('../components/customer/pages/TemplatesPage.vue')
const DetailPage = () => import('../components/customer/pages/DetailPage.vue')
const ProfilesPage = () => import('../components/customer/pages/PhotoLibraryPage.vue')
const ModelingPage = () => import('../components/customer/pages/ModelingPage.vue')
const PreviewPage = () => import('../components/customer/pages/PreviewPage.vue')
const UnlockPage = () => import('../components/customer/pages/UnlockPage.vue')
const RechargePage = () => import('../components/customer/pages/RechargePage.vue')
const DiamondWallet = () => import('../components/customer/DiamondWallet.vue')
const WorksPage = () => import('../components/customer/pages/WorksPage.vue')
const AccountPage = () => import('../components/customer/pages/AccountPage.vue')
const LoginPage = () => import('../components/customer/pages/LoginPage.vue')
const SupportPage = () => import('../components/customer/pages/SupportPage.vue')

const AdminApp = () => import('../components/admin/AdminApp.vue')

// 你原来写的图片风格库组件（HelloWorld.vue，组件名 PicGallery）。
// 重写路由后它不再挂在 “/” 上，这里单独保留一个入口，与新平台页面互不影响。
const PicGallery = () => import('../components/HelloWorld.vue')

const routes = [
  { path: '/', redirect: '/preview' },
  { path: '/home', name: 'home', redirect: '/preview' },
  { path: '/templates', name: 'templates', component: TemplatesPage, meta: { title: '婚纱照模板' } },
  { path: '/templates/:id', name: 'detail', component: DetailPage, meta: { title: '模板详情' } },
  { path: '/profiles', name: 'profiles', component: ProfilesPage, meta: { title: '我的照片图库' } },
  { path: '/modeling', name: 'modeling', component: ModelingPage, meta: { title: '历史身份图' } },
  { path: '/preview', name: 'preview', component: PreviewPage, meta: { title: '创作' } },
  { path: '/unlock', name: 'unlock', component: UnlockPage, meta: { title: '解锁高清成品' } },
  { path: '/recharge', name: 'recharge', component: RechargePage, meta: { title: '微信充值' } },
  { path: '/wallet', name: 'wallet', component: DiamondWallet, meta: { title: '钻石钱包' } },
  { path: '/works', name: 'works', component: WorksPage, meta: { title: '生成' } },
  { path: '/account', name: 'account', component: AccountPage, meta: { title: '我的' } },
  { path: '/login', name: 'login', component: LoginPage, meta: { title: '登录' } },
  { path: '/support', name: 'support', component: SupportPage, meta: { title: '联系客服' } },
  { path: '/admin', name: 'admin', component: AdminApp, meta: { title: '第二光源平台管理后台' } },
  { path: '/gallery', name: 'gallery', component: PicGallery, meta: { title: '图片风格库' } },
  { path: '*', redirect: '/preview' },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL || '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === 'templates' && ['detail', 'preview'].includes(from.name)) return new Promise(resolve => { Vue.nextTick(() => requestAnimationFrame(() => resolve({ x: 0, y: catalogRestoredScroll() }))) })
    return savedPosition || { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => { markCatalogReturn(to, from); next() })

// 让 navigation.js 里的 go()/routeUrl() 能驱动 vue-router
bindNavigator(router)

export default router
